import { LinkContent } from '../../models';
import { ContentButtonLink } from './ContentButtonLink';

interface Props {
    link?: LinkContent;
}

export const LinkContentDisplay = ({ link }: Props): React.ReactElement<any, any> | null => {
    if (!link) {
        return null;
    }

    return (
        <ContentButtonLink to={link.url} className="shadow mb-4 mb-md-4 content-link">
            {link.text || link.url}
        </ContentButtonLink>
    );
};
